import { ProjectHeaderNavProps } from "./ProjectHeaderNav";
import { EuiCollapsibleNavBeta } from "@inscopix/ideas-eui";
import { getTableMenuItems } from "./ProjectHeaderNav.helpers";

type ProjectHeaderNavProjectProps = Pick<
  ProjectHeaderNavProps,
  | "project"
  | "currentTenant"
  | "folders"
  | "tables"
  | "selectedTableId"
  | "setSelectedTableId"
>;

export const ProjectHeaderNavProject = ({
  project,
  currentTenant,
  folders,
  tables,
  selectedTableId,
  setSelectedTableId,
}: ProjectHeaderNavProjectProps) => {
  const tableMenuItems = getTableMenuItems(
    tables,
    folders,
    selectedTableId,
    setSelectedTableId,
  );

  return (
    <EuiCollapsibleNavBeta.Item
      title={project.name}
      icon="tableDensityExpanded"
      isCollapsible={false}
      items={[
        {
          title: "Tables",
          isCollapsible: true,
          accordionProps: {
            initialIsOpen: true,
          },

          items: tableMenuItems,
        },
      ]}
    />
  );
};
